module.exports = __webpack_public_path__ + "static/NikMacKenzie-8ed867db3c6e3ea97d9cba506cb42436.jpg";